import React, { useEffect, useImperativeHandle, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLoader } from "../../components/loader/loader";
import { deleteData, getData, postData, putData } from "../../services/Axios/Axios";
import { ApiUrl } from "../../config/apiConfig";
import { PaginationControls } from "../../models/pagination";
import { showAPiError_mesage } from "../../services/validationService/validationservice";
import messageService from "../../services/message/messageService";
import { ChevronsUpDown, CircleX } from "lucide-react";
import { confirmAction } from "../../utils/utils";
import { formatPhoneNumberd } from "../../services/FormControlService/FormControlServices";
import LinkIcon from "../../components/UIElements/LinkIcon";
import SocialMediaLinks from "../../components/UIElements/SocialMediaLinks";
import DeleteButton from "../../components/UIElements/DeleteButton";
import EditButton from "../../components/UIElements/EditButton";
import NoRecord from "../../components/NoDataScreen/NoRecord";
import Pagination from "../../components/pagination/pagination";

interface BoxTruckProps {
  setSelectedRows: any;
  selectedRows: any;
  addEditModelBoxTruck: any;
  setSelectedPriorities?: React.Dispatch<any>;
}

const BoxTruckTable = React.forwardRef((props: BoxTruckProps, ref) => {
  const { show, hide } = useLoader();
  const [allData, setAllData] = useState<any>([]);
  const [searchdaata, setSearchQuery] = useState<any>("");
  const [ids, setIds] = useState<number[]>([]);
  const [pagination, setPagination] = useState(new PaginationControls());
  const [startIndex, setStartIndex] = useState(0);
  const [selectAll, setSelectAll] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setSelectAll(
      allData.length > 0 && props.selectedRows.length === allData.length
    );
  }, [props.selectedRows, allData]);

  useEffect(() => {
    getDataALLBoxTruckRef();
    return () => {
      console.log("Component unmounted");
    };
  }, [pagination.page]);

  const getDataALLBoxTruckRef = async (search?: any) => {
    const skip = (pagination.page - 1) * pagination.limit;
    const obj: any = { skip_number: skip };
    if (search) obj.search = search;

    try {
      const response = await getData(ApiUrl.listBoxTruck, obj, { show, hide });
      const ids = response.data.map((item: any) => item._id);
      setIds(ids);
      setAllData(response.data);

      if (props.setSelectedPriorities) {
        props.setSelectedPriorities(
          response.data.reduce((acc: any[], item: any) => {
            if (item.priority != null) acc.push(item.priority);
            return acc;
          }, [])
        );
      }

      setPagination((prev:any) => ({ ...prev, count: response.total_count }));
      setStartIndex(
        (pagination.page === 0
          ? 0
          : (pagination.page - 1) * pagination.limit) + 1
      );
    } catch (error: any) {
      showAPiError_mesage(error?.response?.data?.message);
    }
  };

  const handlePageChange = (selectedPage: { selected: number }) => {
    setPagination((prev) => ({ ...prev, page: selectedPage.selected + 1 }));
  };

  const handleSearchChange = (event: any) => {
    setSearchQuery(event);
  };

  const handleSearchSubmit = () => {
    getDataALLBoxTruckRef(searchdaata);
  };



  const deleteBoxData = async (data: any) => {
    const messageServices = messageService();
    messageServices.confirm(`delete this Box Truck`, "").then(async (res) => {
      if (res.value) {
        const response = deleteData(ApiUrl.createBoxTruck+data._id);
        if (await response) {
          getDataALLBoxTruckRef();
          messageServices.toast("success", messageServices.message.deleteSuccess);
        }
      }
    });
  };

  const handleSelectAll = (e: any) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    props.setSelectedRows(checked ? allData.map((item: any) => item._id) : []);
  };

  const handleRowSelect = (id: any) => {
    props.setSelectedRows((prev: any) =>
      prev.includes(id) ? prev.filter((itemId: any) => itemId !== id) : [...prev, id]
    );
  };





  const removePriority = async (data: any) => {
    try {
      await putData(ApiUrl.createBoxTruck+data?._id, { ...data, priority: 9999 });
      getDataALLBoxTruckRef();
      const messageServicesd = messageService();
      messageServicesd.toast("success", "Priority removed successfully");
    } catch (error) {
      console.error(error);
    }
  };

  useImperativeHandle(ref, () => ({
    getDataALLBoxTruckRef,
    handleSearchSubmit,
    handleSearchChange,
    allData,
  }));

  return (
    <>
      <div className="tablebox">
        <div className="tablebox12">
          <div className="scrollbar-box assetsdriver">
            <table className="border-collapse text-black w-full">
              <thead className="whitespace-nowrap bg-[#F6F6F7] border border-[#E2E2E2]">
                <tr className="text-[13px] font-bold bg-customGray">

                 
                  <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>S. No</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Company Name</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Phone Number</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Address</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>MC Number</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>DOT Number</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Website</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Carrier Setup</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Load Board</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Social Links</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody className="whitespace-nowrap border border-[#E2E2E2]">
                {allData.map((data: any, index: number) => (
                  <tr key={index} className="text-[12px] hover:bg-[#f0f0f0]">

                   

                    {/* S.No */}
                    <td className="px-3 border border-[#E2E2E2]">
                      {startIndex + index}
                    </td>

                    {/* Company Name + Priority Badge */}
                    <td className="pl-3 border border-[#E2E2E2]">
                      <div className="flex justify-between w-full h-full items-center">
                        {data?.companyName
                          ? data.companyName.charAt(0).toUpperCase() +
                            data.companyName.slice(1).toLowerCase()
                          : "--"}
                        {data.priority && data.priority !== 9999 && (
                          <span className="bg-green-100 text-xs font-medium me-2 pl-2.5 py-0.5 rounded-md text-green-600 ml-3 flex items-center">
                            Priority : {data.priority}
                            <button
                              onClick={() =>
                                confirmAction(
                                  "Are you sure you want to remove priority",
                                  () => removePriority(data)
                                )
                              }
                              className="ml-3 hover:text-red-500"
                            >
                              <CircleX size={17} />
                            </button>
                          </span>
                        )}
                      </div>
                    </td>

                    {/* Phone */}
                    <td className="px-3 border border-[#E2E2E2]">
                      {data?.phoneNumber
                        ? formatPhoneNumberd(data.phoneNumber)
                        : "--"}
                    </td>

                    {/* Address */}
                    <td className="px-3 border border-[#E2E2E2]">
                      {data?.address ? data.address : "--"}
                    </td>

                    {/* MC Number */}
                    <td className="px-2 border border-[#E2E2E2]">
                      {data?.mcNumber ? data.mcNumber : "--"}
                    </td>

                    {/* DOT Number */}
                    <td className="px-2 border border-[#E2E2E2]">
                      {data?.dotNumber ? data.dotNumber : "--"}
                    </td>

                    {/* Website */}
                    <td className="px-2 border border-[#E2E2E2]">
                      <div className="flex items-center justify-center">
                        <LinkIcon url={data?.website} />
                      </div>
                    </td>

                    {/* Carrier Setup */}
                    <td className="px-2 border border-[#E2E2E2]">
                      <div className="flex items-center justify-center">
                        <LinkIcon url={data?.carrierSetup} />
                      </div>
                    </td>

                    {/* Load Board */}
                    <td className="px-2 border border-[#E2E2E2]">
                      <div className="flex items-center justify-center">
                        <LinkIcon url={data?.loadBoard} />
                      </div>
                    </td>

                    {/* Social Links */}
                    <td className="px-2 border border-[#E2E2E2]">
                      <div className="flex items-center justify-center">
                        <SocialMediaLinks
                          linkedin={data?.linkedin}
                          facebook={data?.facebook}
                          xcom={data?.xcom}
                          instagram={data?.instagram}
                        />
                      </div>
                    </td>

                    {/* Actions */}
                    <td className="text-center items-center px-2 py-[2px] border border-[#E2E2E2]">
                      <div className="flex justify-center items-center gap-2">
                       
                        <DeleteButton onClick={() => deleteBoxData(data)} />
                        <EditButton
                          onClick={() => props.addEditModelBoxTruck(data)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {!allData.length && (
              <NoRecord noDataText="No data available in Box Truck" />
            )}
          </div>
        </div>

        {allData.length > 0 && (
          <Pagination pagination={pagination} onPageChange={handlePageChange} />
        )}
      </div>
    </>
  );
});

export default BoxTruckTable;